import Vue from "vue";
import VueI18n from "vue-i18n";
import { castToVueI18n, createI18n } from "vue-i18n-bridge";

Vue.use(VueI18n, { bridge: true });

// Function to load locale messages
function loadLocaleMessages() {
  const locales = require.context(
    "../locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages: VueI18n.LocaleMessages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

export const i18n = castToVueI18n(
  createI18n(
    {
      legacy: false, // Use the Composition API
      locale: "en-CA", // Default locale
      fallbackLocale: "en", // Fallback locale
      messages: loadLocaleMessages(),
      silentTranslationWarn: process.env.NODE_ENV === "production", // Suppress warnings in production
      missing: (locale, key) => {
        // Handle missing translations
        console.warn(`Missing translation: locale '${locale}', key '${key}'`);
        return key;
      },
    },
    VueI18n
  )
);

// Export translation function
export const t = (i18n as any).global.t as typeof i18n.t;

// Export locale setter function
export const setI18nLocale = (newLocale: string) => {
  i18n.locale = newLocale;
  (i18n as any).global.locale.value = newLocale;
};

Vue.use(i18n);

export default i18n;
